export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_FR_RGB_wht_100217_coming_ssom.2b058a6c.svg";